export enum MessageStripType {
  /**
   * default type (no special styling)
   */
  Information = 'Information',

  /**
   * accept type
   */
  Positive = 'Positive',

  /**
   * reject style
   */
  Negative = 'Negative',

  /**
   * warning type
   */
  Warning = 'Warning'
}
